<template>
    <ValidationObserver ref="observer"
                        tag="form"
                        class="mx-2"
                        @submit.prevent="submit">
        <div class="row d-flex">
            <div class="col-sm-6 py-4">
                
                 <ValidationProvider v-if="currentCompany._id && !ovpJobCondition._id"
                                    tag="div"
                                    vid="period"
                                    class="mb-4"
                                    mode="lazy"
                                    v-slot="{errors}">
                    <label class="d-block text-secondary text-left mb-0">Globālais darba apstāklis</label>
                    <b-form-select id="period" class="w-100 py-1 ds-input" v-model="globalOvpJobCondition" :options="globalJobConditionOptions"/>
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    class="mb-4"
                                    vid="name"
                                    mode="lazy"
                                    :customMessages="{required: 'Norādi darba apstākļa nosaukumu.'}"
                                    rules="required"
                                    v-slot="{errors}">
                    <label for="name" class="d-block text-secondary text-left mb-0">Nosaukums</label>
                    <input type="text" id="name" class="w-100 py-1 ds-input" v-model="ovpJobCondition.name" :disabled="!!currentCompany._id">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    vid="period"
                                    class="mb-4"
                                    mode="lazy"
                                    v-slot="{errors}">
                    <label class="d-block text-secondary text-left mb-0">Periods</label>
                    <b-form-select id="period" class="w-100 py-1 ds-input" v-model="ovpJobCondition.period" :options="[1,2,3]"/>
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    vid="isSpecial"
                                    mode="lazy"
                                    rules="required"
                                    v-slot="{errors}">
                    <b-form-checkbox v-model="ovpJobCondition.isSpecial" name="isActive" switch size="md">
                        Specifisks apstāklis
                    </b-form-checkbox>
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <CustomButton class="w-25 mb-4 ds-btn--success" btn-text="Saglabāt izmaiņas" :is-loading="isActiveRequest"/>
    </ValidationObserver>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import {extend, ValidationObserver, ValidationProvider} from 'vee-validate';
    import {required} from 'vee-validate/dist/rules';

    import CustomButton from '@/components/global/CustomButton';
    import {OvpJobCondition} from '../../vuex/modules/ovp/models/ovp-job-condition.models';
    import * as ovpStoreTypes from '../../vuex/modules/ovp/ovp.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';

    export default {
        name: 'ovp-job-condition-base-form',
        components: {
            CustomButton,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            currentOvpJobCondition: {
                type: OvpJobCondition,
                required: false,
                default: () => new OvpJobCondition,
            },
        },
        data() {
            return {
                ovpJobCondition: {...this.currentOvpJobCondition},
                globalOvpJobCondition: '',
            }
        },
        async created() {
            extend('required', required);

            if (this.currentCompany._id) {
                await this.getGlobalOvpJobConditions({name: ''});
            }
        },
        watch: {
            globalOvpJobCondition(val) {
                const selectedOvpJobCondition = this.globalOvpJobConditions.find(({id}) => id === val);

                this.ovpJobCondition.name = selectedOvpJobCondition.name;
                this.ovpJobCondition.period = selectedOvpJobCondition.period;
                this.ovpJobCondition.isSpecial = selectedOvpJobCondition.isSpecial;
                this.ovpJobCondition.ovpJobConditionId = selectedOvpJobCondition._id;
            }
        },
        computed: {
            ...mapGetters('ovp', {
                /** @type {boolean|*} */
                isActiveRequest: ovpStoreTypes.GET_IS_ACTIVE_REQUEST,
                /** @type {array|*} */
                globalOvpJobConditions: ovpStoreTypes.GET_GLOBAL_OVP_JOB_CONDITIONS,
                /** @type {array|*} */
                ovpJobConditions: ovpStoreTypes.GET_OVP_JOB_CONDITIONS,
            }),
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            globalJobConditionOptions() {
                const addedOvpJobConditions = this.ovpJobConditions.map(({ovpJobCondition}) => ovpJobCondition.id);

                return this.globalOvpJobConditions.filter(({id}) => !addedOvpJobConditions.includes(id)).map(({id, name}) => ({value: id, text: name}))
            },
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('ovp', {
                /** @type {function|*} */
                createOvpJobCondition: ovpStoreTypes.ACTION_CREATE_OVP_JOB_CONDITION,
                /** @type {function|*} */
                updateOvpJobCondition: ovpStoreTypes.ACTION_UPDATE_OVP_JOB_CONDITION,
                 /** @type {function|*} */
                getGlobalOvpJobConditions: ovpStoreTypes.ACTION_GET_GLOBAL_OVP_JOB_CONDITIONS,
            }),
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    return;
                }

                try {
                    const data = {
                        ovpJobCondition: this.ovpJobCondition,
                        companyId: this.currentCompany._id,
                    };

                    if (this.ovpJobCondition._id) {
                        await this.updateOvpJobCondition(data);

                        return this.updateStatus('Darba apstākļa izmaiņas saglabātas!');
                    }

                    await this.createOvpJobCondition(data);

                    this.reset();
                } catch (error) {
                    this.$refs.observer.setErrors({[error.field]: [error.message]});
                }
            },
            updateStatus(message) {
                this.setAlertData({type: 'primary', message});
                this.$emit('finished');
            },
            reset() {
                this.ovpJobCondition = new OvpJobCondition;
                this.$refs.observer.reset();
                this.updateStatus('Darba apstāklis pievienots!');
            },
        }
    }
</script>